import { useEffect } from 'react';

const DEFAULT_WEIGHTS = [400, 700, 900];

export const useWorkSans = (weights: number[] = DEFAULT_WEIGHTS) => {
  const weightsKey = weights.join(';');

  useEffect(() => {
    const link = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css2?family=Work+Sans:wght@${weightsKey}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [weightsKey]);
};
